export default __webpack_public_path__ + "static/media/digiconcrete_logo.bc32a9fa.png";